import moment from 'moment'
import { push } from 'connected-react-router'
const useNewOrdersServerless = process.env.REACT_APP_USE_NEW_ORDERS_SERVERLESS

export const loadMyOrders = (
  pageIndex,
  pageSize,
  initialDate,
  endDate,
  orderId
) => {
  let offset = pageIndex && pageSize ? pageIndex * pageSize : 0
  let formattedInitialDate = initialDate
    ? moment(initialDate).format('DD/MM/YYYY')
    : ''
  let formattedEndDate = endDate ? moment(endDate).format('DD/MM/YYYY') : ''
  orderId = orderId || ''
  return {
    type: 'FETCH_ORDER',
    payload: {
      client: 'cloudloyalty',
      request: {
        method: 'get',
        url: `/v1/purchases/me/orders?orderId=${orderId}&startDate=${formattedInitialDate}&endDate=${formattedEndDate}&offset=${offset}&limit=${pageSize ||
          '10'}`
      }
    },
    page: pageIndex
  }
}

export const setFilterQueryString = days => {
  return push(`/my-orders?days=${days}`)
}

export const getVoucherLink = data => ({
  type: 'GET_VOUCHER_LINK',
  payload: {
    client: 'cloudloyalty',
    request: {
      method: 'post',
      url: '/v1/purchases/voucherLink',
      data
    }
  }
})

export const getOrderListDetails = (parentOrderId, orderId, productId) => {
  return {
    type: 'GET_ORDERLIST',
    parentOrderId: parentOrderId,
    productId: productId,
    orderId: orderId,
    payload: {
      client: 'tracking',
      request: {
        method: 'get',
        url: `/timelines/${orderId}`
      }
    }
  }
}

export const getOrderDetailsApi = (parentOrderId, orderId, productId) => {
  return {
    type: 'FETCH_ORDER_DETAIL_API',
    payload: {
      client: useNewOrdersServerless ? 'order' : 'cloudloyalty',
      request: {
        method: 'get',
        url: `v1/purchases/me/orders?orderId=${parentOrderId}&startDate=&endDate=&offset=0&limit=1`
      }
    },
    parentOrderId: parentOrderId,
    productId: productId,
    orderId: orderId
  }
}

export default {
  loadMyOrders,
  getOrderListDetails,
  setFilterQueryString,
  getOrderDetailsApi,
  getVoucherLink
}



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/actions.js